import React, { ErrorInfo } from 'react';
import core from '@gin-betting/core';

const { sentryHub } = core.services;

interface Props {
    wrappedComponentName: string;
}

interface State {
    error: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
    state = { error: null };

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({ error });
        sentryHub.withScope(scope => {
            scope.setTag('react-component', this.props.wrappedComponentName);
            scope.setExtras(errorInfo as any);

            sentryHub.captureException(error);
        });
    }

    render() {
        if (this.state.error) {
            return null;
        }

        return this.props.children;
    }
}
